import axios, { AxiosInstance } from 'axios'
import { v4 as uuidv4 } from 'uuid'
import MockAdapter from 'axios-mock-adapter'
import { Session } from '../../stores/useAuthStore/useAuthStore'
import { CreateSessionRequestBody } from './types'
import { isApiEndpointMocked } from './utils/isApiEndpointMocked'

export const usePublicAxiosInstance = () => {
    const axiosInstance = axios.create({
        baseURL: import.meta.env.VITE_API_BASE_URL as string,
    })

    axiosInstance.interceptors.request.use(
        (config) => {
            config.headers['X-Trace-Id'] = uuidv4()
            return config
        },
        (error: Error) => {
            return Promise.reject(error)
        }
    )

    mockAxiosInstance(axiosInstance)

    return axiosInstance
}

const mockAxiosInstance = (axiosInstance: AxiosInstance) => {
    const mock = new MockAdapter(axiosInstance)

    if (
        isApiEndpointMocked({
            method: 'post',
            path: '/api/v1/sessions',
        })
    ) {
        mock.onPost('/api/v1/sessions').reply((config) => {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const data = config.data
                        ? (JSON.parse(
                              config.data as string
                          ) as CreateSessionRequestBody)
                        : null

                    if (!data) {
                        resolve([500])
                        return
                    }

                    if (
                        data.username === 'demo@contact.com' &&
                        data.password === 'THGenergy@123!'
                    ) {
                        const response: Session = {
                            accessToken: '123',
                            refreshToken: '123',
                            sessionId: '456',
                        }
                        resolve([200, response])
                        return
                    } else {
                        resolve([401, { message: 'Invalid credentials' }])
                        return
                    }
                }, 2000)
            })
        })
    }

    mock.onAny().passThrough()

    return axiosInstance
}
